import React from 'react';
import './style.css';

const Intro = () => {
	return (
		<header className="home-header">
			<h2>
				We innovate <br /> We deliver <br /> <span>You succeed</span>
			</h2>
		</header>
	);
};

export default Intro;